<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Titel'"
      [name]="'title'"
      [colSize]="12"
      [formField]="form.get('title')">
      <input
        pInputText
        id="title"
        type="text"
        formControlName="title"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Teaser'"
      [name]="'textShort'"
      [colSize]="12"
      [formField]="form.get('textShort')">
      <input
        pInputText
        id="textShort"
        type="text"
        formControlName="textShort"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Inhalt'"
      [floatingLabel]="false"
      [name]="'text'">
      <p-editor
        [modules]="{ nbspFix: true }"
        formControlName="text"
        [style]="{ height: '300px' }">
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button type="button" class="ql-link" aria-label="Link"></button>
          </span>
        </ng-template>
      </p-editor>
    </app-form-field-wrapper>
  </div>
  <div class="grid align-items-center">
    <app-form-field-wrapper
      [label]="'Keywords'"
      [name]="'keywords'"
      [colSize]="10"
      [formField]="form.get('keywords')">
      <p-chips formControlName="keywords" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [colSize]="2"
      [label]="'gesperrt'"
      [name]="'locked'"
      [floatingLabel]="false">
      <p-inputSwitch id="locked" formControlName="locked"></p-inputSwitch>
    </app-form-field-wrapper>
  </div>

  <p-divider></p-divider>
  <app-form-footer
    [hideCancelLink]="true"
    [showRemoveButton]="!!itemToEdit"
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
